module.exports = __webpack_public_path__ + "static/media/Uzbekistan.364530da.png";